import { render, staticRenderFns } from "./DartsArena.vue?vue&type=template&id=0334fadb&scoped=true"
import script from "./DartsArena.vue?vue&type=script&lang=js"
export * from "./DartsArena.vue?vue&type=script&lang=js"
import style0 from "./DartsArena.vue?vue&type=style&index=0&id=0334fadb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0334fadb",
  null
  
)

export default component.exports